"use client";

import { useMemo } from "react";
import { useTable } from "spacetimedb/react";
import { tables } from "@/module_bindings";
import { mapSubscription } from "@/lib/stdb-map";
import type { Organization } from "@/types/organization";
import type { Subscription } from "@/types/subscription";

/**
 * Live `org_subscriptions` view, filtered to `organization` and mapped to the
 * app `Subscription` type. Legacy parity: the old Stripe-backed subscription
 * client only ever listed `status: 'active'` subscriptions — the view
 * carries every status, so that filter moves here.
 */
export function useSubscriptions(organization: Organization | null): {
  subscriptions: Subscription[];
  isReady: boolean;
} {
  const [rows, isReady] = useTable(tables.org_subscriptions);

  const subscriptions = useMemo(() => {
    if (!organization) return [];
    return rows
      .filter(
        (row) =>
          row.organizationId === organization.id && row.status === "active",
      )
      .map(mapSubscription);
  }, [rows, organization]);

  return { subscriptions, isReady };
}
